<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import ProductForm from "./components/ProductForm.vue"

defineProps<{
  product: {
    id?: number | null
    company_id: number | ""
    name: string
    sku: string
    kind: string
    measurement_unit_id: number | ""
    cost_price_cents: string
    can_be_purchased: boolean
  }
  companies: Array<{ id: number; name: string }>
  kinds: Array<{ label: string; value: string }>
  measurement_units: Array<{ label: string; value: number }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <ProductForm
      mode="create"
      title="Produtos"
      subtitle="Cadastre um produto com SKU, unidade e custo para uso em composicao do produto, estoque e compras."
      :product="product"
      :companies="companies"
      :kinds="kinds"
      :measurement-units="measurement_units"
      :errors="errors"
    />
  </AppShell>
</template>

